module.exports = __webpack_public_path__ + "static/about-us-banner-679a12f8be24c7db030ea37687b82a9b.png";